import hydraClient from './hydraClient';
import fetchHydra from './fetchHydra';
export default api => hydraClient(api, fetchHydra);


// WEBPACK FOOTER //
// ./src/dataProvider.js